module.exports = __webpack_public_path__ + "3b66044b39899307ec3c98d4afeea517.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/mask-ribbons.png
// module id = 2368
// module chunks = 0